import React from "react";
import T from "prop-types";

import { PlaceholderText } from "2g-placeholder";

import { ZadostStavLabel } from "b2b/renderers";

import useMessages from "./i18n/useMessages";

export function ZadostEditaceWidgetTitle({ zadost, loading }) {
  const { title } = useMessages();
  return loading ? (
    <PlaceholderText>{title({ id: "" })}</PlaceholderText>
  ) : (
    <span className="b2b-ZadostEditaceWidget-title">
      {title(zadost)}
      <ZadostStavLabel val={zadost.stav} />
    </span>
  );
}

ZadostEditaceWidgetTitle.propTypes = {
  loading: T.bool,
  zadost: T.object
};

export default React.memo(ZadostEditaceWidgetTitle);
